import {ValidatorFn} from "@angular/forms";
import {Observable} from "rxjs";

export class ValidationError {
  constructor(
    readonly messageKey: string,
    readonly params: { [name: string]: any } = {}
    ) {}
}

export class FieldValidationError extends ValidationError{
  constructor(
    readonly messageKey: string,
    readonly field?: FieldName,
    readonly params: { [name: string]: any } = {}
  ){
    super(messageKey, params);
  }
}

export type FieldName = string | Observable<string>

export function requiredFieldValidator(fieldName: FieldName = null): ValidatorFn { return control => {
  if (control.value || control.value === 0) {
    return null;
  } else {
    return { "required" : new FieldValidationError("common.validation.required", fieldName) }
  }
}}

export function customerNumberExistsValidator(existsCustomerNumbers: string): ValidatorFn { return control => {
  if (control.value && !existsCustomerNumbers.includes(control.value)) {
    return null;
  } else {
    return { "customerNumberExists" : new ValidationError("common.validation.account.customerNumberExists") }
  }
}}

const emailRegexp = /^[\w\-.+]+@[a-zA-Z0-9.\-]+\.[a-zA-z0-9]{2,4}$/;

export const emailValidator: ValidatorFn = control => {
  if (!control.value || emailRegexp.test(control.value)) {
    return null;
  } else {
    return { "email": new ValidationError("common.validation.email") }
  }
};

const phoneRegexp = /^[\d\s()\[\]\-.+]*$/;

export const phoneValidator: ValidatorFn = control => {
  if (!control.value || phoneRegexp.test(control.value)) {
    return null;
  } else {
    return { "phone": new ValidationError("common.validation.phone") }
  }
};

const usernameRegexp = /^[\w]*$/;

export const usernameValidator: ValidatorFn = control => {
  if (!control.value || usernameRegexp.test(control.value)) {
    return null;
  } else {
    return { "username": new ValidationError("common.validation.username") }
  }
};

const passwordRegexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

export const passwordValidator: ValidatorFn = control => {
  if (!control.value || passwordRegexp.test(control.value)) {
    return null;
  } else {
    return { "password": new ValidationError("common.validation.password") }
  }
};

export const confirmPasswordValidator: ValidatorFn = control => {
  if (control.get('password').value === null || control.get('password').value === '' || control.get('password').value === control.get('confirmPassword').value) {
    control.get('confirmPassword').setErrors(null);
    return null;
  } else {
    control.get('confirmPassword').setErrors({ "confirmPassword": new ValidationError("common.validation.confirmPassword") });
    return null;
  }
};

const zipRegexp = /^\d{5}$/;

export const zipValidator: ValidatorFn = control => {
  if (!control.value || zipRegexp.test(control.value)) {
    return null;
  } else {
    return { "zip": new ValidationError("common.validation.zip") }
  }
};
